ready = ->
  $("body").on "click", ".add-sector-btn", (e) ->
    $('#register_sector').removeClass 'hide'
    $('#edit_sector, #edit_production_system, #register_production_system').addClass 'hide'

  $("body").on "click", ".edit-sector-btn", (e) ->
    $('#edit_sector').removeClass 'hide'
    $('#register_sector, #edit_production_system, #register_production_system').addClass 'hide'

$(document).on 'turbolinks:load', ready